import AHDate from "_shared/dates/date";
import MessageHistorySchema, { MessageHistoryJSON } from "messaging/_schemas/message-history-schema";

export type MessageHistoryAttachment = { name: string };

export default class MessageHistory {
  public static fromJSON(json: MessageHistoryJSON): MessageHistory {
    const parsed = MessageHistorySchema.MessageHistoryJSONZ.parse(json);
    return new MessageHistory({
      id: parsed.id,
      content: parsed.content ?? undefined,
      subject: parsed.subject ?? undefined,
      created: new AHDate(parsed.created),
      updated: parsed.updated ? new AHDate(parsed.updated) : undefined,
      attachments: (parsed.attachments ?? []).map((attachment) =>
        typeof attachment === "string"
          ? { name: attachment }
          : { name: attachment.name ?? "Unnamed attachment" },
      ),
      attachmentCount: parsed.attachmentCount ?? parsed.attachments?.length ?? 0,
    });
  }

  public static fromJSONArray(jsonArray: MessageHistoryJSON[]): MessageHistory[] {
    return jsonArray.map((json) => MessageHistory.fromJSON(json));
  }

  public readonly id: string;
  public readonly content?: string;
  public readonly subject?: string;
  public readonly created: AHDate;
  public readonly updated?: AHDate;
  public readonly attachments: MessageHistoryAttachment[];
  public readonly attachmentCount: number;

  private constructor(params: {
    id: string;
    content?: string;
    subject?: string;
    created: AHDate;
    updated?: AHDate;
    attachments: MessageHistoryAttachment[];
    attachmentCount: number;
  }) {
    this.id = params.id;
    this.content = params.content;
    this.subject = params.subject;
    this.created = params.created;
    this.updated = params.updated;
    this.attachments = params.attachments;
    this.attachmentCount = params.attachmentCount;
  }
}
